import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { SVGICON } from '../constant/theme';

const MainPagetitle = ({pageTitle, parentTitle, mainTitle, title}) => {
	const { t } = useTranslation();
	const pt = pageTitle || title || 'Page';
	const mt = mainTitle || t('nav.dashboard');
	const hasFullBreadcrumb = parentTitle && parentTitle !== pt;
    return (
        <>
            <div className="page-titles">
				<ol className="breadcrumb">
					<li><h5 className="bc-title">{mt}</h5></li>
					{hasFullBreadcrumb ? (
						<>
							<li className="breadcrumb-item">
								<Link to={"/dashboard"}>{SVGICON.HomeSvg} {parentTitle}</Link>
							</li>
							<li className="breadcrumb-item active">{pt}</li>
						</>
					) : (
						<li className="breadcrumb-item active">{pt}</li>
					)}
				</ol>
			</div>
        </>
    );
};

export default MainPagetitle;
